import { render, staticRenderFns } from "./ArmaPage.vue?vue&type=template&id=07fc582c"
import script from "./ArmaPage.js?vue&type=script&lang=js&external"
export * from "./ArmaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports